import { z } from "zod";

export const DORMANT_SURFACES = [
  "express-interest",
  "recommended",
  "invitations",
  "match-status",
  "quiz",
  "connections",
] as const;

export type DormantSurface = (typeof DORMANT_SURFACES)[number];

export const dormantSurfaceListSchema = z
  .string()
  .default("")
  .transform((value) =>
    value
      .split(",")
      .map((surface) => surface.trim())
      .filter(Boolean),
  )
  .pipe(z.array(z.enum(DORMANT_SURFACES)));
